"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLogger = void 0;
const react_1 = require("react");
const logger_1 = require("../context/logger");
/**
 * Returns a scoped Logger instance from the LoggerContext.
 * @param scope The logger's Scope name
 */
const useLogger = (scope) => {
    const [logger] = react_1.useState(react_1.useContext(logger_1.LoggerContext).withScope(scope));
    return logger;
};
exports.useLogger = useLogger;
//# sourceMappingURL=use-logger.js.map